// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQ_root__hsv9S","answerHeight":"FAQ_answerHeight__lgDQx"};